export default __webpack_public_path__ + "static/media/automate.954723f8.png";